type ResolveCompletedDraftUploadsOptions<T> = {
    getCurrentRevision: () => number
    getCurrentActionRequests: () => T[]
    resolve: (actionRequests: T[]) => Promise<T[]>
    commit: (actionRequests: T[]) => void
}

export async function resolveCompletedDraftUploads<T>({
    getCurrentRevision,
    getCurrentActionRequests,
    resolve,
    commit,
}: ResolveCompletedDraftUploadsOptions<T>): Promise<boolean> {
    while (true) {
        const revision = getCurrentRevision()
        const actionRequests = getCurrentActionRequests()
        const nextActionRequests = await resolve(actionRequests)
        if (nextActionRequests === actionRequests) return false
        if (getCurrentRevision() !== revision) continue

        commit(nextActionRequests)
        return true
    }
}
